// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"11896111","977":"2eef3593"}[chunkId] + ".chunk.js";
};